import wx from "weixin-js-sdk";
import axios from "axios";
import store from '../store'

const  { VUE_APP_BASE_URL, VUE_APP_JAVA_URL, VUE_APP_PHP_URL, VUE_APP_APPID } = process.env

const APPID = VUE_APP_APPID;
console.log(APPID,'appid')
//自动登录完 清除 url code 参数
function deleteCodeParams() {
    let url = window.location.href
    if (url.indexOf('?code=') != -1) {
      sessionStorage.setItem('hadWxAuth', true)
      // 创建URL对象
      let parsedUrl = new URL(url);
      // 移除code参数
      parsedUrl.searchParams.delete("code");
      parsedUrl.searchParams.delete("state");
      // 获取新的链接
      let newUrl = parsedUrl.toString();
      // 跳转到新的URL
      history.pushState(null, '', newUrl)
    }
}

//获取 url code 参数
export function getQueryCode(){
    let result ='';
    const str =window.location.search.split("code=");
    if(str[1]){
      result = str[1].split("&state=123")[0]
    }
    return result;
}

export function parse_url(key = "") {
    // 定义函数
    if (key === "") {
      return "";
    }
    const url = window.location.href;
    const reCat01 = `/${key}=[^&]*/g`;
    const reCat = eval(`(${reCat01})`); // 对象化
    let value;
  
    try {
      value = window.location.href
        .split("?")[1]
        .match(reCat)[0]
        .replace(`${key}=`, "");
    } catch (e) {
      value = "";
    }
    return value;
}

export const wxSdk = {
  isWxBrowser: () => {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger" && ua.indexOf("windowswechat") == -1;
  },
  WxAutoLogin: async (openId, unionId, type) => {

      if (sessionStorage.getItem('todayIsLogin')) {
        let localuserInfo = localStorage.getItem('userInfo')
        if (localuserInfo) {
          localuserInfo = JSON.parse(localuserInfo)
          const access_token = 'Bearer ' + localuserInfo.access_token;
          store.commit("userInfo/setAccessToken", access_token);//存入缓存
          store.commit("userInfo/setUser", localuserInfo);//存入缓存
          return
        }
      }
      
      if (openId && unionId) {
        const form = new FormData();
        form.append('openId', openId)
        form.append('unionId', unionId)
        form.append('appId', APPID)
        form.append('channelType', 1202)
        axios.post(`${ VUE_APP_JAVA_URL }/u/v3/users/auto/login`,
          form,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
              'terminal': 7
            }
          }
        ).then(res => {
          let data = res.data.data
          if (!data.hasUnionIdBinding && !localStorage.userInfo) {
            return
          }
          let userInfo = {
            "access_token": data.access_token,
            "uid": data.ucId,
            "name": data.nick,
            "mobile": data.mobile,
            "avatar": data.avatar,
            "expires_in": data.expires_in,
            "huatuId": data.huatuId
          }
          const access_token = 'Bearer ' + userInfo.access_token;
          store.commit("userInfo/setAccessToken", access_token);//存入缓存
          store.commit("userInfo/setUser", userInfo);//存入缓存

        })
      }
  },
  setWxCode(d) {
      //获取 openid 的接口暂不支持测试环境，测试环境暂时使用 /lumenapi/general/wechat/openid 代替线上接口
      let getOpenIdUrl = process.env.NODE_ENV == 'production' ?  `${ VUE_APP_BASE_URL }/api/common/wechat/openId` : `${ VUE_APP_PHP_URL }/lumenapi/general/wechat/openid`
      axios.get(getOpenIdUrl,{
          params: {
            appId: `${APPID}`,
            code: d
          }
      }).then(async (res) => {
        let reslove = JSON.parse(JSON.stringify(res.data.data))
        if (process.env.NODE_ENV == 'development') {
            // 本地环境写死unionid
            reslove.unionId = 'ouCUiwdDKfxzaAowIDFEN4_A4eqo'
        }
        localStorage.setItem('UserUnionID', reslove.unionId ? reslove.unionId : '');
        localStorage.setItem('UserOpenID', reslove.openId ? reslove.openId : '');
        localStorage.setItem('wxAvatar', reslove.headerImg ? reslove.headerImg : '')
        localStorage.setItem('wxNick', reslove.nickname ? reslove.nickname : '')

        await this.WxAutoLogin(reslove.openId, reslove.unionId, 'update')
        deleteCodeParams()
    })
    .catch(err => {
        Toast.fail("服务异常，请刷新浏览器重试！", 8);
        deleteCodeParams()
    });
  },
  getWxCode() {
      const local = window.location.href
      console.log(local,'local')
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          setTimeout(() => {
            const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent(
              local
            )}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`
            window.location.href = url
          }, 1000)
        } else {
          const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent(
            local
          )}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`
          window.location.href = url
        }
      })
  },
  isNeedCode() {
      // 微信浏览器内 且 url 不携带token
      if (this.isWxBrowser()) {
        // cookie 中没有 openid 和 unionid 走微信授权
        if (!localStorage.getItem('UserOpenID') || !localStorage.getItem('UserUnionID')) {
          // 获取url上code
          const paramsCode = parse_url('code') || getQueryCode()
          if (paramsCode) {
            // 拿到微信code
            this.setWxCode(paramsCode)
          } else {
            this.getWxCode()
          }
        } else {
          this.WxAutoLogin(localStorage.getItem('UserOpenID'), localStorage.getItem('UserUnionID'))
          
          deleteCodeParams()
        }
      }
  },
  // 保存微信昵称头像
  saveWxInfo(json) {
    if (!localStorage.getItem('UserOpenID') || !localStorage.getItem('UserUnionID') || !localStorage.getItem('wxAvatar') || !localStorage.getItem('wxNick')) {
      return false
    }
    axios.post(`${process.env.VUE_APP_JAVA_URL}/u/v3/users/weChat/avatar`,
      {
        unionId: localStorage.getItem('UserUnionID'),
        openId: localStorage.getItem('UserOpenID'),
        avatar: localStorage.getItem('wxAvatar'),
        nick: localStorage.getItem('wxNick'),
        appId: APPID
      },
      {
        headers: {
          token: json.token,
          cv: "7.1.5",
          terminal: 7
        },
      }
    ).then((res) => {
      console.log('保存昵称、头像成功')
    })
  }
}